module.exports = __webpack_public_path__ + "static/media/PDF9.64d12063.pdf";